import React from "react";
import { Box } from "@mui/material";

export default function QBEOauth() {
  return (
    <Box>Successfully connected to QuickBooks. You can close this popup now.</Box>
  );
}
